const UNKNOWN_SOURCES = new Set(['', 'unavailable', 'unknown', 'none', 'null']);

export const usableResourceCost = (resource = {}) => {
  resource = resource || {};
  const amount = Number(resource.cost_per_month);
  const source = String(resource.cost_source || '').trim().toLowerCase();
  if (!Number.isFinite(amount) || amount < 0 || UNKNOWN_SOURCES.has(source)) return null;
  return amount;
};

export const usableCostBreakdown = (resource = {}) => {
  resource = resource || {};
  const amount = usableResourceCost(resource);
  const breakdown = resource.cost_breakdown;
  const total = Number(breakdown?.total);
  const components = breakdown?.components;
  if (amount === null || !Number.isFinite(total) || !Array.isArray(components) || !components.length) return null;
  const tolerance = Math.max(0.01, Math.abs(amount) * 0.01);
  return Math.abs(total - amount) <= tolerance ? breakdown : null;
};

export const summarizeResourceCosts = (resources = []) => {
  const priced = resources
    .map((resource) => ({ resource, amount: usableResourceCost(resource) }))
    .filter(({ amount }) => amount !== null);
  return {
    priced,
    pricedCount: priced.length,
    unknownCount: Math.max(0, resources.length - priced.length),
    total: priced.reduce((sum, item) => sum + item.amount, 0),
  };
};
